import { useLocationConfiguration } from "@tlc/ls2pac/components/LocationConfiguration";
import { useStationLocation } from "@tlc/ls2pac/components/StationLocation";
import { useMemo } from "react";

export function useDownloadNowBlocked() {
  const { stationLocation } = useStationLocation();
  const { locationConfiguration } = useLocationConfiguration();
  const { overrideDownloadNowStationLocation } =
    locationConfiguration?.pacSettings || {};

  const downloadNowBlocked = useMemo(
    () => !!stationLocation && !overrideDownloadNowStationLocation,
    [stationLocation, overrideDownloadNowStationLocation],
  );

  return downloadNowBlocked;
}
